<template>
  <div class="ml-5 pt-0">
    <v-speed-dial
      v-model="fab"
      :top="showCart"
      :right="showCart"
      direction="bottom"
      transition="slide-y-transition"
      style="z-index:99;"
    >
      <template #activator>
        <v-badge
          :value="!!cartItemCount"
          :content="cartItemCount"
          color="red"
          offset-x="20"
          offset-y="20"
        >
          <v-btn
            v-model="fab"
            :fab="showCart"
            elevation="0"
            :outlined="!showCart"
            :color="showCart ? 'blue darken-2' : ''"
            :dark="opt.dark || false"
            :light="opt.light || false"
            :small="!cartItemCount"
            v-on="showCart || auth.set ? {} : {click: showLogin}"
          >
            {{ showCart ? '' : auth.name || 'Login' }}
            <v-icon
              class="pl-1"
              :large="showCart"
            >
              {{ navIcon }}
            </v-icon>
          </v-btn>
        </v-badge>
      </template>
      <v-btn
        v-show="showCart"
        fab
        dark
        small
        color="green"
        @click="checkout"
      >
        <v-icon>mdi-cart-check</v-icon>
      </v-btn>
      <v-btn
        v-show="showCart"
        fab
        dark
        small
        color="red"
        @click="emptyCart"
      >
        <v-icon>mdi-cart-off</v-icon>
      </v-btn>

      <v-btn
        v-show="auth.set"
        fab
        dark
        small
        @click="showLogin"
      >
        <v-icon>mdi-account</v-icon>
      </v-btn>

      <v-btn
        v-show="!showCart && auth.set"
        fab
        dark
        small
        color="red"
        @click="logout"
      >
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-speed-dial>
    
    <account-dialog
      :stripe-options="stripeOptions"
      :user-slot="userSlot"
      :options="options"
    />

    <cart-dialog />
  </div>  
</template>

<script>
import AccountDialog from './dialog/Index'
import CartDialog from '../market/cart/Dialog.vue'

export default {
  components: { AccountDialog, CartDialog },
  props: {
    options: {
      type: Object,
      default: ()=>{return {}}
    },
    stripeOptions: {
      type: Object,
      default: ()=>{return {}}
    },
    userSlot: {
      type: Object,
      default: ()=>{return {}}
    }
  },
  data: () => ({
    fab: false,
    tabs: null,
  }),
  computed: {
    opt(){return this.options || {}},
    cartItemCount(){return this.$store.getters['market/cartItemCount'](this.context)},
    showCart(){return !!this.cartItemCount},
    navIcon(){
      if (this.fab) {
        return 'mdi-close'
      } else if (this.cartItemCount) {
        return 'mdi-cart'
      } else if (this.auth.set) {
        return 'mdi-account-circle'
      }
      return 'mdi-login'
    },
    // aaa(){return this.api.context}
  },
  created(){
    this.$store.dispatch('account/INIT_AUTH')
    let route = this.$route || {}
    if (route.name == 'token_login'){
      this.tokenLogin(route.params.token)
    }
  },
  methods: {
    emptyCart(){
      this.$store.commit('market/emptyCart', this.context)
    },
    
    checkout(){
      this.$store.commit('market/openCloseCartDialog', true)
    },

    logout(){
      this.api.logout()
    },

    showLogin(){
      this.$store.commit('account/SHOW_AUTH_DIALOG')
    },

    async tokenLogin(token){
      try {
        let res = await this.api.loginWithToken(this.context, token)
        this.$store.dispatch('account/LOGIN', {...res, login:true})
        this.$router.push('/')
      } catch (error) {
        this.$router.push('/')
        console.log('token is not valid or expired...', {error})        
        this.$store.commit('market/openSnackbar', {
          text: 'You\'re Awesome, but the login link is invalid or expired',
          icon: 'mdi-fire',
          timeout: 4000
        })
      }
    }

  },
}
</script>